import { Provider } from '@angular/core'

import { AuthService } from '@yoshu-lib/core/auth/auth.service'
import { AUTH_SERVICE } from '@yoshu-lib/core/tokens/auth-service.token'

export const provideTrevesAuthService = (): Provider => ({
  provide: AUTH_SERVICE,
  useExisting: AuthService
})
